module.exports = __webpack_public_path__ + "media/Video 101.73cae7e9.mp4";